<script>
    import Library, {getItem} from '../../Models/LibraryORM';
    import Loader from '../Loader.svelte';

    import {addFormModal} from '../../Forms/ModalFormManager.svelte';

    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from '../Confirmation.svelte';
    import SortableTable from '../SortableTable.svelte';
    import parseFields from '../../Utilities/parseFields';

    import {userMap} from '../../Utilities/Session.svelte';

    export let params;

    let sortFields, formFields;
    let oldItem, newItem;

    function loadLibrary(library_store) {
        if (!library_store) return;

        let fieldData = parseFields(library_store.fields);

        formFields = fieldData.formFields;
        sortFields = fieldData.sortFields;
    }

    function rejectItem(item) {
        confirm("Are you sure you want to reject changes?").then(() => {
            item.delete().then(() => {
                notifier.success("Changes rejected");
                closeModal()
            }).catch(() => {
                pass;
            })
        }).catch(() => null)
    }

    function approveItem(newItem, oldItem) {
        if (oldItem === newItem) {
            const cloned = JSON.parse(JSON.stringify(newItem));

            library.items.newItem(cloned).then(() => {
                notifier.success("Library Item Added")
                newItem.delete();
                closeModal();
            });
        } else {
            for (let field of formFields) {
                oldItem[field.name] = newItem.details[field.name];
            }

            Library.save(oldItem).then(() => {
                newItem.delete().then(() => {
                    notifier.success("Changes Approved");
                    closeModal();
                });
            });
        }

    }

    function editItem(item) {
        addFormModal({
            fields: formFields,
            data: item.details
        }).then((data) => {
            library.save(data).then(() => {
                notifier.success("Item Updated")
            });
        }).catch(() => {});
    }

    async function reviewItem(item) {
        newItem = item;

        if (item.details.template_id) {
            try {
                oldItem = await getItem(item.details.template_id);
            } catch {
                oldItem = newItem;
            }
        } else {
            oldItem = newItem;
        }
    }

    function closeModal() {
        oldItem = undefined;
        newItem = undefined;
    }

    $: library = new Library(params.id);
    $: library_store = library.store;

    $: loadLibrary($library_store);
</script>

<Loader loading={!$library_store}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            {library.details.name}
            <a href="#/library/{params.id}" class="button is-pulled-right">Close</a>
        </h1>
        <SortableTable
            {sortFields}
            tableData={[...$library_store.moderation_queue]}
            addedColumns = 3
            ORM="true"
        >
            <svelte:fragment slot="appendHeaders">
                <th>Submitter</th>
                <th>Change Type</th>
                <th>Change Comment</th>
            </svelte:fragment>
            <svelte:fragment slot="appendColumns" let:row={item}>
                <td>{$userMap[item.details.submitter] || item.details.submitter}</td>
                <td>{#if item.details.template_id}Update{:else}New{/if}</td>
                <td>{item.details.changeComment || ""}</td>
            </svelte:fragment>
            <div slot="rowActions" let:row={item}>
                <div class="buttons is-centered">
                    <button class="button" on:click={() => reviewItem(item)}>Review</button>
                    <button class="button is-info" on:click={() => editItem(item)}>Edit</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>

{#if oldItem && newItem}
<div class="modal is-active">
    <div class="modal-background" on:click="{closeModal}"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Compare Items</p>
                <span class="delete" aria-label="close" on:click|preventDefault={closeModal}></span>
            </header>
            <section class="modal-card-body">
                <table class="table is-fullwidth is-striped">
                    <thead>
                        <tr>
                            <th>Field</th>
                            {#if oldItem !== newItem}
                                <th>Old</th>
                            {/if}
                            <th>New</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each sortFields as field}
                            <tr class:is-changed={oldItem !== newItem && JSON.stringify(oldItem[field.field]) !== JSON.stringify(newItem.details[field.field])}>
                                <th>{field.label}</th>
                                {#if oldItem !== newItem}
                                    <td>
                                        {#if field.component}
                                            <svelte:component this={field.component} value={oldItem[field.field]} {...field.componentProps} />
                                        {:else}
                                            {oldItem[field.field]}
                                        {/if}
                                    </td>
                                {/if}
                                <td>
                                    {#if field.component}
                                        <svelte:component this={field.component} value={newItem.details[field.field]} {...field.componentProps} />
                                    {:else}
                                        {newItem.details[field.field]}
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-danger" on:click={() => rejectItem(newItem)}>Reject</button>
                <button class="button is-success" on:click={()=> approveItem(newItem, oldItem)}>Approve</button>
            </footer>
        </div>
    <button class="modal-close is-large" aria-label="close" on:click="{closeModal}"></button>
  </div>
{/if}

<style>
    .is-changed {
        background-color: #defffa !important;
    }

    .modal-card-body {
        max-height: calc(100vh - 175px);
    }
</style>